// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mail-check-solid';

export const Component = () => (
  <path d='M24.377 2.86 20.45 6.789a.434.434 0 0 1-.335.144.434.434 0 0 1-.335-.144l-1.964-1.436a.542.542 0 0 1-.143-.383c0-.335.143-.48.479-.48.143 0 .239.048.287.097l1.628 1.198 3.64-3.64c.048-.096.144-.144.335-.144.335 0 .48.144.48.479a.54.54 0 0 1-.145.383V2.86Zm-6.225 4.072H1.485c-.431 0-.766.144-1.054.431A1.378 1.378 0 0 0 0 8.37v.335l9.052 5.843c.239.144.526.239.766.239s.527-.096.766-.24l9.052-5.842V8.37a1.38 1.38 0 0 0-.431-1.006 1.411 1.411 0 0 0-1.054-.431Zm-8.334 8.813a2.61 2.61 0 0 1-1.293-.336L0 9.854V20.15c0 .431.144.766.431 1.054.288.287.623.43 1.054.43h16.667c.43 0 .766-.143 1.053-.43.288-.288.432-.623.432-1.054V9.854l-8.573 5.555a2.56 2.56 0 0 1-1.245.336h-.001Z' />
);

export const viewBox = '0 0 25 25';
